import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import Help from '../../../generics/help';
import SvgIcon from 'react-icons-kit';
import {printer} from 'react-icons-kit/icomoon/printer';
import {search} from 'react-icons-kit/icomoon/search';
import ModalPersonSearch from '../../../generics/modal_person_search';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');

class KardexHemovigilance extends Component{
	constructor(props){
		super(props);

		this.setTable = this.setTable.bind(this);
		this.updateState = this.updateState.bind(this);
		this.onPrint = this.onPrint.bind(this);
		this.person_search = this.person_search.bind(this);
		this.onSearch = this.onSearch.bind(this);

		this.state = {
			index:-1,
			items:[],
			aux_id:"",
			load:false,
			columns:[
				{title:'Fecha Hora', width:'13%'},
				{title:'Acción', width:'50%'},
				{title:'Usuario', width:'18%'},
				{title:'Documento', width:'17%'}
			],
			listado:[],
			date_hour:"",
			medical:"",
			health_facilities_id:"",
			filename:'Reporte Kardex Hemovigilancia',
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	componentDidMount(){

		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		})


		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){		
		this.$el = $(this.el);
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						
						doc.content.splice(2, 0, {text: 'Fecha de emisión '+this.state.date_hour, margin:[10,0,0,10] });
						
						var table = doc.content[3].table;
					
						table.body.map((body)=>{
							body.splice(3, 1);
						})
                		doc.content[3].table.widths=["10%","80%","10%"];
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
			//data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"39em",
			scrollX: true,
			autoWidth: false,
			ordering:false,
			info:false,
			
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	_handleSearch = (query) => {
	    this.setState({load: true});
		fetch(Config.default.apiGateway.URL+'unit_delivered/search_transfusion?search='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				response.map((res) => {
					res.name = res.names+' '+res.lastname1+' '+res.lastname2+
								(res.folio !== null ? ' - '+res.folio : "") +
								' - '+moment(res.delivered_date).format('DD/MM/YYYY')+
								' - '+res.unit_number+
								' - '+res.code+' '+res.component_number+
								' - '+res.origin;
				})
				
				this.setState({
					load: false,
			      	items: response
			    });

			    setTimeout(()=>{
			    	if(this.modal_person_search.state.show){
			    		var id = '';
			    		this.modal_person_search.state.list.map((p)=>{
			    			if(p.check){
			    				id = p.person_id;
			    			}
			    		});


			    		var index = response.findIndex(obj => 
			    			parseInt(obj.id) === parseInt(id)
			    		);

			    		if(index !== -1){
			    			this.getInfo([this.state.items[index]]);
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}else{
			    			swal('Información', 'El paciente seleccionado ya se encuentra en el listado', 'info')
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}
			    	}
			    	
			    }, 500);
			}
		})
	}

	updateState = name => e=>{
		if(e.length > 0){
			var index = this.state.items.findIndex(obj => 
				obj.id === parseInt(e[0].id)
			);

			this.setState({
				aux_id:e[0].id, 
				index:index,
				items:[]
			});

			this.onSearch(e[0].id);
		}
	}

	onSearch(id){
		var obj = {aux_id:id};

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'reports/kardex_hemovig',{
			method:'POST',
			body:JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(msg => {
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				setTimeout(()=>{
					this._typeahead.getInstance().blur();	
				}, 500);

				var list = [];
				response.map((res) => {
					list.push([
						moment(res.date).format('DD/MM/YYYY HH:mm'),
						res.action,
						res.user,
						res.document+'/'+res.doc_id
					]);
				});

				

				setTimeout(()=>{
					if(this.modal_person_search.state.show){
						this.modal_person_search.handleClose();
					}
					this.props.waiting.handleShow('Cargando...');
					this.$el = $(this.el);
					this.$el.DataTable().destroy();
					//this.$el.empty();
					setTimeout(()=>{
						this.setState({listado:list});
						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
					}, 500)
				}, 500);
				
				
				
			}
		})
	}

	async onPrint(type, id){
		this.props.waiting.handleShow('Imprimiendo...');
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;
		obj.file_type = type;
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.props.waiting.handleClose();
			this.setState({show:false});
		}else{
			this.props.waiting.handleClose();
		}
	}

	person_search(){
		this.modal_person_search.handleShow('Paciente','patients');
	}

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Pacientes ->
					Kardex Hemovigilancia
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_patients"} 
		            submenu={"help_kardex_hemovig"}  />
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-8">
						<AsyncTypeahead
				          	labelKey={(option) => `${option.name}`}
				          	minLength={0}
				          	name="unit_aux_id"
				          	id="unit_aux_id"
				          	inputProps={{
				          		name:"aux_id",
				          		required: true,
				          		id:"aux_id",
				          		autoComplete:"off",
				          	}}
				          	onSearch={this._handleSearch}
				          	placeholder="Búsqueda..."
				          	options={this.state.items}
				          	onChange={this.updateState('items')}
				          	ref={ref => this._typeahead = ref}
				          	useCache={false}
				          	isLoading={this.state.load}
				          	selectHintOnEnter={true}
				          	selected={this.state.items.length > 0 && this.state.index !== -1?
				          		[this.state.items[this.state.index]]
				          		: []}
				          	delay={600}
				          	paginationText="Mostrar mas resultados..."
				        />
				    </div>
				    <div className="col-xs-12 col-sm-2">
						<SvgIcon icon={search} size={20} style={{cursor:'pointer', marginLeft:'10px'}} 
							onClick={this.person_search}/>
					</div>
				</div>
				<div className="col-xs-12" id="table-to-pdf">									
					<div className="table-responsive">
						<table style={{fontSize:"11px"}} className={"table"} id="table-to-xls" 
							width="100%" ref={el => this.el = el}>
							<tbody>
								{this.state.listado.map((list, i)=>(
									<tr key={i}>
										{list.map((l, j)=>(
											j === list.length - 1?
												<td key={j}>
													{l !== "/0" && <button className="btn btn-info btn-sm" name={l}
														value={l} title="Imprimir" 
														onClick={()=>this.onPrint(l.split('/')[0], l.split('/')[1])}>
														<SvgIcon icon={printer} />
													</button>}
												</td>
											: <td key={j}>
												{l}
											</td>
										))}
									</tr>
								))}
							</tbody>
						</table>
					</div>

				</div>

				<ModalPersonSearch {...this.props} 
					waiting={this.props.waiting} 
					updatePerson={this.updateState} 
					onRef={ref => (this.modal_person_search = ref)} 
					search={this.onSearch}
					persons={this.state.items}
				/>
				
			</div>
		) 
	}
}

export default translate('translations')(KardexHemovigilance);